import ModelComponent from './index.vue'
const Model = {}

Model.install = function(Vue) {
  const ModelConstructor = Vue.extend(ModelComponent)
  const instance = new ModelConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$Model = (params) => {
    instance.setDialogType(params.dialogType, params.payload)
    Object.keys(params).forEach(key => {
      const obj = instance[key]
      if (Object.prototype.toString.call(obj) === '[object Object]') {
        instance[key] = Object.assign({}, obj, params[key])
      } else {
        instance[key] = params[key]
      }
    })
    return new Promise((resolve, reject) => {
      instance.submitAction = resolve
      instance.cancleAction = reject
    })
  }
}

export default Model
